import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateRows: '1fr 1fr',
    padding: '24px',
    width: '100%',
    borderRadius: 6,
    backgroundColor: theme.palette.background.paper
  },
  logoContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%'
  },
  image: {
    width: 95,
    height: 75,
    objectFit: 'fill'
  },
  nameContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'flex-end'
  }
}))
